<template>
  <div class="app-container">
    <el-card v-loading="loading">
      <div slot="header">
        <span>租户详情</span>
        <el-button style="float: right;" type="primary" size="small" @click="goBack">返回</el-button>
      </div>
      <el-form label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="租户ID">
              <span>{{ tenant.tenantId }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="租户编号">
              <span>{{ tenant.tenantNo }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="租户名称">
              <span>{{ tenant.name }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="域名">
              <span>{{ tenant.domain }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态">
              <el-tag :type="tenant.status | statusFilter">{{ tenant.status }}</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="过期时间">
              <span>{{ tenant.expireAt | parseTime }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人">
              <span>{{ tenant.contactPerson }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话">
              <span>{{ tenant.contactPhone }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系邮箱">
              <span>{{ tenant.contactEmail }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间">
              <span>{{ tenant.createdAt | parseTime }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Logo">
              <img v-if="tenant.logoUrl" :src="tenant.logoUrl" style="max-width: 200px; max-height: 100px;">
              <span v-else>暂无Logo</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">API配置</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="订单API地址">
              <span>{{ tenant.config && tenant.config.orderApiUrl || '未配置' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品API地址">
              <span>{{ tenant.config && tenant.config.productApiUrl || '未配置' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="App Key">
              <span>{{ tenant.config && tenant.config.appKey || '未配置' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="App Secret">
              <span>{{ tenant.config && tenant.config.appSecret ? '******' : '未配置' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">完整配置JSON</el-divider>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="配置信息">
              <el-input
                v-model="configJson"
                type="textarea"
                :rows="10"
                readonly
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getTenant } from '@/api/tenant'

export default {
  name: 'TenantDetail',
  filters: {
    statusFilter(status) {
      const statusMap = {
        active: 'success',
        inactive: 'info',
        expired: 'danger'
      }
      return statusMap[status]
    },
    parseTime(time) {
      if (!time) return ''
      const date = new Date(time)
      return date.toLocaleString()
    }
  },
  data() {
    return {
      tenant: {},
      configJson: '',
      loading: false
    }
  },
  created() {
    this.loadTenant()
  },
  methods: {
    async loadTenant() {
      const tenantId = this.$route.params.id
      this.loading = true
      try {
        const res = await getTenant(tenantId)
        this.tenant = res.data
        this.configJson = JSON.stringify(this.tenant.config, null, 2)
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    goBack() {
      this.$router.push('/tenant/list')
    }
  }
}
</script>

<style scoped>
</style>
